var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home-route"}},[_c('div',{staticClass:"weather-widget-container"},[_c('open-weather-widget',{attrs:{"api-key":"46d1179af8fab8ec6d893553fbe8f031"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }